import { ThemeOptions, createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import { getBaseTheme } from './baseTheme';
import { getThemedComponents } from './components';

const baseTheme = createTheme(getBaseTheme() as ThemeOptions);
export const theme = deepmerge(baseTheme, getThemedComponents(baseTheme));
